// extracted by mini-css-extract-plugin
module.exports = {"leavePopup":"leave-popup_leavePopup__gnuiE","leavePopupContent":"leave-popup_leavePopupContent__bt4D-","leavePopupBtn":"leave-popup_leavePopupBtn__ecoBU"};